<template>
  <div class="ggtf-modal-overlay" :class="{ show: show }">
    <div class="ggtf-modal-content" @click.stop>
      <div class="ggtf-modal-header">
        <h3>{{ $t('_ggtf._ssjymm') }}</h3>
        <button class="ggtf-close-btn" @click="show = false">
          <CloseCircleOutlined style="font-size: 22px" />
        </button>
      </div>
      <div class="ggtf-modal-body">
        <div class="ggtf-detail-info">
          <div class="ggtf-detail-section">
            <!-- <h5>购买金额</h5> -->
            <input v-model="password" type="password" class="input-box" style="width: 100%" :placeholder="$t('_ggtf._qssjymm')" />
          </div>
        </div>
      </div>
      <div class="ggtf-modal-footer">
        <button class="ggtf-cancel-btn" @click="show = false">{{ $t('_ggtf._qx') }}</button>
        <button class="ggtf-confirm-btn" @click="onSubmit()">{{ okText|| $t('_sp._qrzf') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
export default {
  name: 'PasswordVue',
  components: { CloseCircleOutlined },
  emits: ['sumbit'],
  props: {
    okText: {
      type: String,
      defualt: ""
    }
  },
  data() {
    return {
      show: false,
      password: ''
    }
  },
  methods: {
    open() {
      this.password = ''
      this.show = true
    },
    close() {
      this.show = false
    },
    onSubmit() {
      this.$emit('sumbit', this.password)
      // this.show = false
    }
  }
}
</script>

<style></style>
